<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      row-id="expoInfoCode"
      resizable
      border
      :checkbox-config="{
        highlight: true,
        reserve: true,
        checkMethod: ({ row }) => !['D'].includes(row.expoInfoStatus),
      }"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
      @cell-click="cellClick"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.expoInfoStatus === 'D'
              ? 'danger'
              : row.expoInfoStatus === 'N'
              ? 'light'
              : 'success'
          "
        >
          {{ row.expoInfoStatusName }}
        </el-tag>
      </template>

      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="handleCommand">
            <span class="el-dropdown-link">
              {{ $l('choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                icon="el-icon-view"
                :command="{
                  pageType: 'detail',
                  expoInfoCode: row.expoInfoCode,
                }"
              >
                {{ $l('btn_view_details') || '查看详情' }}
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-edit"
                divided
                :command="{
                  pageType: 'edit',
                  expoInfoCode: row.expoInfoCode,
                }"
                v-if="
                  allow('M') &&
                  row.expoInfoStatus != 'D' &&
                  row.expoInfoStatus != 'Y'
                "
              >
                {{ $l('btn_view_edit') || '编辑' }}
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-delete"
                :command="{
                  pageType: 'del',
                  expoInfoCode: row.expoInfoCode,
                }"
                v-if="allow('D') && row.expoInfoStatus == 'N'"
              >
                {{ $l('btn_view_del') || '删除' }}
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-s-check"
                divided
                :command="{
                  pageType: 'audit',
                  expoInfoCode: row.expoInfoCode,
                }"
                v-if="allow('C') && row.expoInfoStatus == 'N'"
              >
                {{ $l('btn_view_review') || '审核' }}
              </el-dropdown-item>
              <el-dropdown-item
                icon="el-icon-date"
                divided
                :command="{
                  pageType: 'update',
                  expoInfoCode: row.expoInfoCode,
                }"
                v-if="allow('U') && row.expoInfoStatus != 'D'"
              >
                {{ $l('btn_update') || '展会时间变更' }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    handleCommand(command) {
      const { pageType, expoInfoCode } = command

      switch (pageType) {
        case 'detail':
          this.$emit('openEditPage', {
            pageType: pageType,
            expoInfoCode,
          })
          break
        case 'edit':
          this.$emit('openEditPage', {
            pageType: pageType,
            expoInfoCode,
          })
          break
        case 'del':
          this.del(expoInfoCode)
          break
        case 'audit':
          this.audit(expoInfoCode)
          break
        case 'update':
          this.$emit('update', {
            expoInfoCode,
          })
          break

        default:
          return
      }
    },
    del(expoInfoCode) {
      this.$confirm(
        this.$l('tips_delete') || '是否要删除该记录？',
        this.$l('label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.expoInfoDelApi({ expoInfoCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    audit(expoInfoCode) {
      this.$confirm(
        this.$l('tips_audit') || '是否审核该记录？',
        this.$l('label_completeDesc_audit') || '确认信息',
        {
          confirmButtonText:
            this.$l('product_dialog_btn_confirm_audit') || '确定',
          cancelButtonText: this.$l('btn_cancel_audit') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.expoInfoAuditApi({ expoInfoCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('tips_audit_ok') || '审核成功！',
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    checkboxChange({ records, reserves }) {
      this.$emit('checkbox-change', records.concat(reserves))
    },
    clearCheckboxRow() {
      this.$refs.table.clearCheckboxRow()
      this.$refs.table.clearCheckboxReserve()
      this.$emit('checkbox-change', [])
    },
    cellClick({ row, column }) {
      if (row.expoInfoStatus == 'D') return
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt']
      if (filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)

      const data = $table
        .getCheckboxRecords(true)
        .concat($table.getCheckboxReserveRecords(true))
      this.$emit('checkbox-change', data)
    },
  },
}
</script>
